"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _utils = require("../../lib/utils");

var _AppLinks = _interopRequireDefault(require("../shared/elements/AppLinks"));

var _newsletterSignup = require("@evdy/web-redux/dist/actions/pages/newsletterSignup");

require("../../sass/components/pages/ContactSection.css");

var _checkCircleIcon2x = _interopRequireDefault(require("../../images/pages/check-circle-icon@2x.png"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ContactSection = /*#__PURE__*/function (_React$Component) {
  _inherits(ContactSection, _React$Component);

  var _super = _createSuper(ContactSection);

  function ContactSection(props) {
    var _this;

    _classCallCheck(this, ContactSection);

    _this = _super.call(this, props);
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.handleNewsletterSignup = _this.handleNewsletterSignup.bind(_assertThisInitialized(_this));
    _this.state = {
      newsletterEmail: '',
      hasSubscribed: false
    };
    return _this;
  }

  _createClass(ContactSection, [{
    key: "handleInputChange",
    value: function handleInputChange(e) {
      this.setState({
        newsletterEmail: e.target.value
      });
    }
  }, {
    key: "handleNewsletterSignup",
    value: function handleNewsletterSignup(e) {
      var _this2 = this;

      e.preventDefault();
      this.props.actions.newsletterSignupAction(this.state.newsletterEmail, 'Sites - Contact Section').then(function () {
        _this2.setState({
          newsletterEmail: '',
          hasSubscribed: true
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          currentPage = _this$props.currentPage,
          customClass = _this$props.customClass;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('contact-section-container', customClass)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "contact-wave-divider-top"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "contact-section"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "contact-links"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "company-links"
      }, /*#__PURE__*/_react.default.createElement("strong", null, "ACCOUNT"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        href: "/careers",
        onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_footer_careers"))
      }, "Careers")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        href: "/press",
        onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_footer_press"))
      }, "Press")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        href: "https://everdays.com/blog/",
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_footer_moments"))
      }, "Moments")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        href: 'mailto:' + this.props.contact,
        onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_footer_contact_us"))
      }, "Contact Us")))), /*#__PURE__*/_react.default.createElement("div", {
        className: "support-links"
      }, /*#__PURE__*/_react.default.createElement("strong", null, "SUPPORT"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        href: "/how-to-plan-a-funeral/",
        onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_footer_funeral_planning"), 'link_press')
      }, "Funeral Planning")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        href: "http://help.everdays.com/using-everdays-at-your-funeral-home",
        onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_footer_help_center"))
      }, "Help Center")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        href: "https://everdays.com/terms/",
        onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_footer_tos"))
      }, "Terms of Service")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
        href: "https://everdays.com/privacy/",
        onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_footer_privacy_policy"))
      }, "Privacy Policy")))), /*#__PURE__*/_react.default.createElement("div", {
        className: "app-links"
      }, /*#__PURE__*/_react.default.createElement("strong", null, "Download the app"), /*#__PURE__*/_react.default.createElement(_AppLinks.default, null)))), /*#__PURE__*/_react.default.createElement("div", {
        className: "newsletter-section"
      }, !this.state.hasSubscribed ? /*#__PURE__*/_react.default.createElement("div", {
        className: "subscribe-input"
      }, /*#__PURE__*/_react.default.createElement("span", null, "Sign up for our weekly newsletter"), /*#__PURE__*/_react.default.createElement("form", {
        className: "newsletter-input",
        onSubmit: this.handleNewsletterSignup
      }, /*#__PURE__*/_react.default.createElement("input", {
        required: true,
        type: "text",
        placeholder: "Email address",
        value: this.state.newsletterEmail,
        onChange: this.handleInputChange
      }), /*#__PURE__*/_react.default.createElement("button", {
        onClick: (0, _utils.googleAnalytics)("".concat(currentPage, "_newsletter_submit"))
      }, "Submit"))) : /*#__PURE__*/_react.default.createElement("div", {
        className: "subscribe-confirmation"
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: _checkCircleIcon2x.default
      }), /*#__PURE__*/_react.default.createElement("span", null, "Thanks for subscribing to our newsletter."))));
    }
  }]);

  return ContactSection;
}(_react.default.Component);

ContactSection.defaultProps = {
  currentPage: 'home',
  customClass: ''
};

var mapStateToProps = function mapStateToProps(_ref) {
  var newsletterSignup = _ref.newsletterSignup;
  return {
    newsletterSignup: newsletterSignup
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0, _redux.bindActionCreators)({
      newsletterSignupAction: _newsletterSignup.newsletterSignupAction
    }, dispatch)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ContactSection);

exports.default = _default;